import {
    InfoCircleOutlined,
    QuestionCircleOutlined,
} from '@ant-design/icons';
import cn from 'classnames';
import React, {FC} from 'react';
import {useDispatch} from 'react-redux';

import {useAppSelector} from 'store/config/hooks';
import {selectIsAuthenticated} from 'store/slices/auth-slice';
import {openModal} from 'store/slices/modals-slice';

import {useFooterText} from './hooks/use-footer-text';

import './footer.less';

export const Footer: FC = () => {
    const dispatch = useDispatch();
    const isAuthorized = useAppSelector(selectIsAuthenticated);
    const {footerText, loginInfo} = useFooterText();

    const handleOnClick = () => dispatch(
        openModal({modalName: 'listGridModal', entityName: 'administration.settings.helpdesk'}),
    );
    const handleOnClickAppInfo = () => dispatch(openModal({modalName: 'listModal', entityName: 'app.version'}));

    return (
        <footer className={cn('footer', {dark: isAuthorized, fixed: !isAuthorized})}>
            {!isAuthorized && (
                <div className="footer__block">
                    <div
                        onClick={handleOnClick}
                        className="footer__button"
                    >
                        <InfoCircleOutlined
                            className="footer__button-icon"
                        />
                        <span className="footer__text">Отдел поддержки пользователей</span>
                    </div>
                    <div className="footer__delimiter">|</div>
                    <div
                        onClick={handleOnClickAppInfo}
                        className="footer__button"
                    >
                        <QuestionCircleOutlined
                            className="footer__button-icon"
                        />
                        <span className="footer__text">Информация о приложении</span>
                    </div>
                </div>
            )}
            {footerText && <div className={cn('footer__text', 'footer__credits')}>{footerText}</div>}
            {loginInfo.date && loginInfo.ip && (
                <div className="footer__login-info">
                    <span>Вход: {loginInfo.date}</span>
                    <span>IP: {loginInfo.ip}</span>
                </div>
            )}
        </footer>
    );
};
